import * as yup from 'yup'

export const reportProductionValidation = yup.object().shape({
    laporanTersedia: yup.boolean(),
    jumlahB3Dihasilkan: yup.number().when('laporanTersedia', {
        is: true,
        then: (schema) => schema.min(1, 'Tidak boleh angka 0').required('Harus diisi'),
        otherwise: (schema) => schema.notRequired(),
    }),
    prosesProduksi: yup.string().notRequired()
})

export const generateReportProductionValidation = yup.object().shape({
    companyId: yup.string().required("Harus diisi"),
    tipeProdukDihasilkan: yup.string().required("Harus diisi"),
    dataBahanB3Id: yup.string().when('tipeProdukDihasilkan', {
        is: (val) => val === 'Bahan Berbahaya dan Beracun',
        then: (schema) => schema.required("Harus diisi"),
        otherwise: (schema) => schema.notRequired(),
    }),
    registrasiId: yup.string().when('tipeProdukDihasilkan', {
        is: (val) => val === 'Bahan Berbahaya dan Beracun',
        then: (schema) => schema.required("Harus diisi"),
        otherwise: (schema) => schema.notRequired(),
    }),
    namaProduk: yup.string().when('tipeProdukDihasilkan', {
        is: (val) => val === 'Non Bahan Berbahaya dan Beracun',
        then: (schema) => schema.required("Harus diisi"),
        otherwise: (schema) => schema.notRequired(),
    }),
})